import { render } from "./EducationModal.vue?vue&type=template&id=4276ab24&scoped=true&ts=true"
import script from "./EducationModal.vue?vue&type=script&lang=ts"
export * from "./EducationModal.vue?vue&type=script&lang=ts"

import "./EducationModal.vue?vue&type=style&index=0&id=4276ab24&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4276ab24"]])

export default __exports__